import React from "react";
import { Box, Heading, Text, Container, SimpleGrid, VStack, Icon, useColorModeValue } from "@chakra-ui/react";
import { FaSolarPanel, FaBatteryFull, FaHome, FaIndustry } from "react-icons/fa";
import { PiSolarRoofThin } from "react-icons/pi";
import { TbSolarElectricity } from "react-icons/tb";
const ServiceCard = ({ title, description, icon }) => {
  return (
    <VStack
      align={"center"}
      bg={useColorModeValue("white", "gray.700")}
      p={5}
      borderRadius="md"
      boxShadow="md"
      spacing={3}
    >
      <Icon as={icon} w={10} h={10} color="brand.500" />
      <Heading as="h3" size="md">
        {title}
      </Heading>
      <Text textAlign="center">{description}</Text>
    </VStack>
  );
};

function Services() {
  const services = [
    {
      title: "Solar Panel Installation",
      description: "High-efficiency solar panels for optimal energy production.",
      icon: FaSolarPanel,
    },
    {
      title: "Electrical Solution",
      description: "Customize electrical systems that meet the specific needs of each client.",
      icon: TbSolarElectricity,
    },
    // {
    //   title: "Residential Solutions",
    //   description: "Custom solar solutions for homes of all sizes.",
    //   icon: FaHome,
    // },
    {
      title: "Commercial Projects",
      description: "Large-scale solar installations for businesses and industries.",
      icon: FaIndustry,
    },
    {
      title: "Roofing Membrane",
      description: "High-performance roofing membrane designed for waterproofing and protecting roof structures.",
      icon: PiSolarRoofThin,
    },
    
  ];

  return (
    <Box py={20}>
      <Container maxW={"container.xl"}>
        <Heading as="h1" size="2xl" mb={10} textAlign="center">
          Our Services
        </Heading>
        <SimpleGrid columns={{ base: 1, md: 2, lg: 4 }} spacing={10}>
          {services.map((service, index) => (
            <ServiceCard key={index} {...service} />
          ))}
        </SimpleGrid>
      </Container>
    </Box>
  );
}

export default Services;